module.exports = __webpack_public_path__ + "static/media/background2.8e38db0f.svg";